import { Apis } from "libs/apis";
import Swal from "sweetalert2";

export const manageAdmin = () => {
  const getUserByToken = async (setAdminProfile: any) => {
    try {
      const response = await Apis.getUserByToken();
      setAdminProfile(response.data.data);
    } catch (error) {
      localStorage.removeItem("token");
      localStorage.removeItem("adminProfile");
      window.location.href = "/login";
      setAdminProfile(null);
    }
  };
  return { getUserByToken };
};
